// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ods-container {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 10px;
    justify-items: center;
    align-items: center;
    margin: 2% 15%;
  }
  
  .imagen:hover:not(.no-hover) {
    transform: scale(1.08);
  }
  
  .no-hover {
    pointer-events: none; 
  }

  .ods-container img {
    max-width: 100%;
    height: auto;
    border-radius: 5%;
  }

  /* Responsive design */
@media screen and (max-width: 800px) {
    .ods-container {
      grid-template-columns: repeat(3, 1fr);
    }
    .ods-container img {
      max-width: 8rem;
      height: auto;
    }
  }

  @media screen and (max-width: 680px) {

    .ods-container {
      grid-template-columns: 1fr;
    }
  
    .ods-container img {
      max-width: 8rem;
      height: auto;
    }
  }`, "",{"version":3,"sources":["webpack://./src/styles/ODS.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,qBAAqB;IACrB,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IAEE,sBAAsB;EACxB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,iBAAiB;EACnB;;EAEA,sBAAsB;AACxB;IACI;MACE,qCAAqC;IACvC;IACA;MACE,eAAe;MACf,YAAY;IACd;EACF;;EAEA;;IAEE;MACE,0BAA0B;IAC5B;;IAEA;MACE,eAAe;MACf,YAAY;IACd;EACF","sourcesContent":[".ods-container {\n    display: grid;\n    grid-template-columns: repeat(6, 1fr);\n    gap: 10px;\n    justify-items: center;\n    align-items: center;\n    margin: 2% 15%;\n  }\n  \n  .imagen:hover:not(.no-hover) {\n    -webkit-transform: scale(1.08);\n    transform: scale(1.08);\n  }\n  \n  .no-hover {\n    pointer-events: none; \n  }\n\n  .ods-container img {\n    max-width: 100%;\n    height: auto;\n    border-radius: 5%;\n  }\n\n  /* Responsive design */\n@media screen and (max-width: 800px) {\n    .ods-container {\n      grid-template-columns: repeat(3, 1fr);\n    }\n    .ods-container img {\n      max-width: 8rem;\n      height: auto;\n    }\n  }\n\n  @media screen and (max-width: 680px) {\n\n    .ods-container {\n      grid-template-columns: 1fr;\n    }\n  \n    .ods-container img {\n      max-width: 8rem;\n      height: auto;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
